import React, { Suspense, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Router } from 'react-router-dom'
import history from '../../History'
import FloorWardenAcceptor from '../../components/FloorWarden/AcknowledgeForm'
import GuardianLayout from './Layout'
import Loading from '../../components/Loading'
import Routes from './Routes'
import TenantConfig from '../../components/Admin/TenantConfigurator'
import UserConfig from '../../components/UserConfigurator'
import './styles.css'
import { useShowTenantConfigurator } from '../../components/Admin/Hooks/useShowTenantConfigurator'
import useInit from '../../hooks/useInit'

function Guardian() {
    const { isAcknowledged, population, loading } = useShowTenantConfigurator()
    useInit()
    
    document.title = 'BSS Guardian'

    return (
        <Router history={history}>
            <GuardianLayout>
                <FloorWardenAcceptor />
                <TenantConfig
                    loading={loading}
                    acknowledgement={isAcknowledged}
                    population={population}
                />
                <UserConfig />
                <Suspense fallback={<Loading />}>
                    <Routes />
                </Suspense>
            </GuardianLayout>
        </Router>
    )
}

export default Guardian
